export default "__VITE_ASSET__CMUm4Dap__"